import styles from "../../../styles/Components/alert-system/alert-config/AlertConfigOption.module.css";
import { useSelector } from "react-redux";
import { Button, Skeleton } from "antd";

function AlertConfigOption({ children, ...props }) {
  const {
    alertSystem: { alertStatusLoading: loading, activeAlertLoading },
  } = useSelector((state) => state);
  const { title, icon, configName, onClick } = props;

  const isTelegramOption = title === "Telegram Notification";

  const clickHandler = (e) => {
    e.stopPropagation();
    if (onClick) {
      onClick();
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.title}>
        {icon}
        <h3>{title}</h3>
      </div>
      {loading ? <Skeleton.Input className={styles.loader} active /> : children}
      {!isTelegramOption && (
        <Button
          className={`${styles.btn}`}
          disabled={loading || activeAlertLoading}
          onClick={clickHandler}
        >
          Change
        </Button>
      )}
    </div>
  );
}

export default AlertConfigOption;
